module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/vi/6-057307970b45b00595e5a6eacb7ab226.jpg";